enum GeneralSettingPermission {
  Prem_General_Setting_Open = 'Prem_General_Setting_Open',
  Prem_Sales_Lock_Control = 'Prem_Sales_Lock_Control',
  Prem_Sales_Lock_Override = 'Prem_Sales_Lock_Override',
}

export default GeneralSettingPermission;
